/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Prompt extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return Prompt.fixupPrototype; }

    static newInstance(model: Partial<Prompt>): Prompt {
        let obj = Object.assign(new Prompt(), model);
        Prompt.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Prompt>): Prompt {
        if (!model) return null;
        return Prompt.newInstance(<Prompt> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Prompt) {
        if (!obj) return;

        models.Prompt.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Prompt): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, Prompt.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Input given to the agent
     */
    prompt: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * Name of the user who created the prompt.
     */
    created_by: string;

    /**
     * Type of the prompt
     */
    prompt_type: models.AgentPromptTypes;

}
